import { ColorSwatch } from "@swivl-mono/ui";

import "./BrandColorRow.scss";

interface Props {
  label: string;
  color: string;
  name: string;
  onColorChange: (name: string, color?: string) => void;
}

export function BrandColorRow(props: Props) {
  const { onColorChange, name, color, label } = props;

  return (
    <div className="BrandColorRow mb-2 flex flex-row items-center justify-center">
      <ColorSwatch color={color} name={name} onColorChange={onColorChange} />
      <div className="mb-0 ml-2 flex flex-1 flex-row items-center justify-start">
        <label className="brand label m-0 p-0">{label}</label>
      </div>
    </div>
  );
}
